export default "__VITE_ASSET__nc0g07J6__"